import React, { useState } from 'react';
import { MagnifyingGlass, UserPlus, X } from '@phosphor-icons/react';

const PRIO_KLEUR = { paars: '#7C3AED', rood: '#DC2626', oranje: '#EA580C', groen: '#16A34A', grijs: '#6B7280' };
const fmtDD = (iso) => (iso ? iso.slice(0, 10).split('-').reverse().join('/') : 'nooit');

/** Zoek een klant op naam/stad/postcode en zet ze bij in een bestaande route.
 *  onZoek(term) → lijst klanten · onBijzetten(klant) → true bij succes. */
export const KlantBijzetten = ({ onZoek, onBijzetten, kleur = '#002FA7', open: openInit = false, hint = '' }) => {
  const [open, setOpen] = useState(openInit);
  const [term, setTerm] = useState('');
  const [res, setRes] = useState(null);
  const [bezig, setBezig] = useState('');

  const zoek = async () => {
    const t = term.trim();
    if (t.length < 2) return;
    setBezig('zoek');
    try { setRes(await onZoek(t) || []); } finally { setBezig(''); }
  };

  const bijzet = async (k) => {
    setBezig(k.klant_id);
    try { if (await onBijzetten(k)) { setRes(null); setTerm(''); setOpen(false); } }
    finally { setBezig(''); }
  };

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} className="w-full h-11 border border-dashed text-sm font-bold inline-flex items-center justify-center gap-1.5 bg-white"
        style={{ borderColor: kleur, color: kleur }} data-testid="kb-open"><UserPlus size={16} weight="bold" /> Klant bijzetten</button>
    );
  }
  return (
    <div className="bg-white border p-3" style={{ borderColor: kleur }} data-testid="kb-paneel">
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-sm font-bold" style={{ color: kleur }}>Klant bijzetten in deze route</span>
        <button type="button" onClick={() => { setOpen(false); setRes(null); }} className="h-8 w-8 inline-flex items-center justify-center text-gray-400" data-testid="kb-sluit"><X size={16} /></button>
      </div>
      <div className="flex gap-2">
        <input className="field-input h-11 flex-1" placeholder="naam, bedrijf, stad of postcode" value={term} enterKeyHint="search" autoComplete="off"
          onChange={e => setTerm(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); zoek(); } }} data-testid="kb-input" />
        <button type="button" onClick={zoek} disabled={bezig === 'zoek'} className="h-11 px-4 text-sm font-bold text-white inline-flex items-center gap-1.5 disabled:opacity-50"
          style={{ background: kleur }} data-testid="kb-zoek"><MagnifyingGlass size={16} weight="bold" /> {bezig === 'zoek' ? '…' : 'Zoek'}</button>
      </div>
      <p className="text-[11px] text-gray-500 mt-1.5">{hint || 'De klant komt automatisch op de slimste plek in de route — tijden en km worden herberekend.'}</p>
      {res && (
        <div className="mt-2 border border-gray-200 max-h-[44vh] overflow-y-auto" data-testid="kb-resultaten">
          {!res.length && <div className="p-4 text-center text-sm text-gray-400">Geen klant gevonden</div>}
          {res.map(k => (
            <div key={k.klant_id} className="flex items-center gap-2 p-2.5 border-b border-gray-100" data-testid={`kb-res-${k.klant_id}`}>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-sm truncate">{k.klant_naam}</div>
                <div className="text-xs text-gray-600 truncate">{k.adres?.tekst}</div>
                <div className="flex flex-wrap items-center gap-x-2 text-[11px] text-gray-500 mt-0.5">
                  {k.prioriteit?.label && <span className="px-1.5 py-0.5 text-white font-bold" style={{ background: PRIO_KLEUR[k.prioriteit.kleur] || '#6B7280' }}>{k.prioriteit.label}</span>}
                  <span>Laatste bezoek: <b>{fmtDD(k.laatste_bezoek)}</b></span>
                </div>
              </div>
              <button type="button" disabled={!!bezig || k.in_route} onClick={() => bijzet(k)} className="h-10 px-3 text-xs font-bold border shrink-0 bg-white disabled:opacity-40"
                style={{ borderColor: k.in_route ? '#16A34A' : kleur, color: k.in_route ? '#16A34A' : kleur }} data-testid={`kb-add-${k.klant_id}`}>
                {k.in_route ? '✓ Al in route' : bezig === k.klant_id ? 'Bezig…' : '+ Bijzetten'}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default KlantBijzetten;
